module.exports = __webpack_public_path__ + "img/explain.8997b3e4.jpg";